export class GdsgOperationalWarning {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketStartMs",
            "baseName": "bucketStartMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgOperationalWarning.attributeTypeMap;
    }
    constructor() {
    }
}
